﻿import React, { useState, useEffect } from 'react';
import { NavLink } from "react-router-dom";
import GlobalDialog from '../Modal/GlobalDialog';
import { ModalMetadata } from '../../models/modal-metadata';
import { ModalMessageType } from '../../models/enums';
import { HelpDocument } from '../../models/help-document';
import { CrudFunctions } from '../../utilities/crud-functions'
import { MathJaxContext, MathJax } from 'better-react-mathjax';

import { Button } from 'devextreme-react/button';

const m1 = "\\(x = {-b \\pm \\sqrt{b ^ 2 - 4ac} \\over 2a}\\)";
const emc = "\\(E=mc^2\\)"
const m3 = "\\(\\frac{10}{4x} \\approx 2^{12}\\)";

const line1 = "\\(x+1\\over x-1\\)";

const line2 = "\\(\\sum_{i=1}^{10} t_i\\)";


export interface Props {
    documentId?: number;
    parentId?: string;
    height?: string;
}

export default function MathJaxDocumentationComponent(props: Props) {
    const [instructions, setInstructions] =
        useState<HelpDocument>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>();

    useEffect(() => {
        getAllData();
    }, []);

   return (
        <div className="pw-form-container">
            <div className="lq-header pw-margin-bottom-05">
                <div className="lq-header-title">Calculation Details</div>
            </div>

           <MathJaxContext>

               <MathJax>
                   <div>
                       {/*
                       <input type='number' width="100" onChange={onValueChanged}></input>
                       <h4>Subheader G1</h4>
                       <span>{m1}</span>
                       <br />
                       <br />
                       <div>
                           <span>{formula && formula.laTeX ? formula.laTeX : undefined}</span>
                       </div>

                       <button id={formula && formula.id ? formula.id : undefined} onClick={onClickFormula}>DEFINE</button>
                       <br />
                       <br />
                       <p>{emc}</p>
                       <br />
                       <p>{`\\(x+1\\over x-${expVal}\\)`}</p>
                       */}

                       <div>
                           <span>{m1}</span>
                       </div>
                       <div>
                           <span>{line1}</span>
                       </div>
                       <br /><br />
                       <div>
                           <span>{line2}</span>
                       </div>
                       <br /><br />

                       <div>
                           <span>{`\\(tbw \\times ctp / 100\\over csc/100 \\times (ppc/100 \\times ebd) \\times a/100\\)`}</span>
                       </div>
                       <br /><br />
                       <div>
                           <span>{`\\({\\Large  tbw \\times ctp / 100}\\over {\\Large csc/100 \\times (ppc/100 \\times ebd) \\times a/100} \\)`}</span>
                       </div>

                   </div>
               </MathJax>
           </MathJaxContext>

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata} onClose={clearGlobalDialog} />
            }

        </div>
    );

    async function getDocument() {
        if (props.documentId) {
            await CrudFunctions.getData(`documentation/helpdocument/${props.documentId}/${props.parentId}`)
                .then(data => {
                    setInstructions(data.html);
                })
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Retrieving Instructions");
                });
        }
    }

    async function getAllData() {
        //await getDocument();
    }

    //navigation

    function goBack() {
        history.back();
    }

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }


    function clearGlobalDialog() {
        setGlobalDialogMetadata(null);
        setGlobalDialogVisible(false);
    }
}
